import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from './BaseModal';

const PolicyModal = ({ isOpen, onClose, type }) => {
  const { t } = useTranslation();

  const getContent = () => {
    switch(type) {
      case 'terms':
        return {
          title: t('policy.terms.title'),
          content: t('policy.terms.content')
        };
      case 'privacy':
        return {
          title: t('policy.privacy.title'),
          content: t('policy.privacy.content')
        };
      case 'cookies':
        return {
          title: t('policy.cookies.title'),
          content: t('policy.cookies.content')
        };
      default:
        return { title: '', content: '' };
    }
  };

  if (!isOpen) return null;

  const { title, content } = getContent();

  return (
    <BaseModal 
      isOpen={isOpen} 
      onClose={onClose}
      maxWidth="max-w-4xl"
    >
      <div className="pt-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6 pr-8">{title}</h2>
        
        <div className="prose prose-invert max-w-none">
          <div className="text-white/80 leading-relaxed whitespace-pre-line text-sm sm:text-base">
            {content}
          </div>
        </div>

        <div className="mt-6 sm:mt-8 flex justify-end">
          <button
            onClick={onClose}
            className="btn-primary"
          >
            {t('policy.close')}
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default PolicyModal;
